<template>
  <v-app dark>
    <div>            
      <v-dialog v-model="showerCharacterManager">
        <character-manager :password="credentials.password" :email="credentials.username" style="max-height:90vh!important; overflow:hidden"></character-manager>
      </v-dialog>
    </div>
    <div>      
      <div v-if="admin && connected" style="z-index:3; position:absolute; right:10px; top:10px">        
        <v-menu>          
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="white">settings </v-icon>
          </template>
          <v-list color="brown darken-4">
            <v-list-item v-if="!admin">
            <v-btn @click="loginDialog= true; maybeFastTrack()">
              login
            </v-btn>
            </v-list-item>
            <v-list-item v-if="admin && connected">
            <v-btn @click="downloadGame(); downloadDialog = true" style="background-color:antiquewhite">
              download
            </v-btn>
            </v-list-item>
            <v-list-item v-if="admin && connected">
            <v-btn @click="uploadDialog = true" dark color="brown">
              upload
            </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-img v-if="!connected" style="min-height:1000px; height:100vh; display:flex; align-content:center" :src="require('@/assets/books.jpg')">
      <!-- <div style="margin-left:200px">
        <v-btn v-if="credentials.username == 'admin1'" @click="migrateDatabase()">Migrate</v-btn>
      </div> -->
      <v-row style="width:100%; z-index:1; height:120px; top:6px" class="mr-0 ml-0 mb-4 pa-0">
        <v-col md="1" xs="1" class="mt-1 ml-0 pl-1">
        <v-btn v-if="!connected" href="./site/home" style="height:50px; width:125px;" contain>
          <v-img style="height:50px; width:125px;" :src="require('@/assets/home button.png')">
          </v-img>
        </v-btn>
      </v-col>
        <v-col md="10" sm="12" style="height:100%; top:9px; margin-right:0px; margin-bottom:16px; margin-top:34px" class="pa-0">
          <v-img  :src="require('@/assets/lil_bar.png')" style="height:100%; top:3px; align-items:normal; text-align:center; padding-top:14px" contain class="ma-1">
            <div v-if="!connected && (admin || hasPlayerAccount)">
              <br/><span v-if="admin || hasPlayerAccount" style="color:white; max-width:300px">Logged In As: {{credentials.username}}</span>
              <br/><v-btn class="mt-2 mr-6" style="height:30px; background-color:antiquewhite" @click="showerCharacterManager = !showerCharacterManager">Class Manager</v-btn>
              <v-btn class="mt-2 ml-6" style="height:30px; background-color:antiquewhite" @click="logout()">logout</v-btn>
            </div>
            <div v-else class="mt-4">
              <span style="color:white">No Account</span>
              <br/><v-btn @click="loginDialog = true" small class="mt-2">Login</v-btn>
            </div>
          </v-img>
        </v-col>
      </v-row>
<!-- !admin &&  && !isPlayer && !isDm -->
      <v-row justify="space-around" style="padding-top:100px">
        <v-col md="4" sm="6">
          <v-card>
            <v-img :src="require('@/assets/parchment background.jpg')">
              <v-card-title class="headline" style="justify-content:center">Join As Player</v-card-title>
                <v-row class="ml-1" style="max-width: 100%; align-items: baseline; margin-bottom:16px; margin-left:0px!important">
                  <v-form v-model="claimNameValid" style="width:60%">
                  <v-text-field
                    v-model="unclaimedName"
                    :rules="[rules.nameLength, rules.legalName]"
                    class="pl-2"
                    label="Enter Name"                                        
                  ></v-text-field>
                  </v-form>
                  <v-btn class="ml-2" small :disabled="!claimNameValid" @click="setPlayerName" style="background-color:antiquewhite">Claim Name</v-btn>                  
                </v-row>
                <v-row style="justify-content:center; margin-bottom:16px">
                  <v-btn class="ml-2" large :disabled="!playerName" @click="getServerList(); gotServers=true" style="background-color:antiquewhite">get server list</v-btn>
                </v-row>
                <v-img :src="require('../assets/Inventory_bar 2.png')" v-if="serverList.length > 0" contain class="repeaty" style="border-width:4px 0px; border-style:ridge; border-color:saddlebrown">
                  <ul class="light" style="max-height:60vh; margin-top:-2px; margin-left:4px; margin-right:4px; margin-bottom:4px; padding-top:16px; overflow-y:auto">
                    <li v-for="(item, index) in serverList" :key="index" class="ml-2 mr-2 mb-4" style="display:grid; font-weight:500; font-size:22px;">                      
                      <div style="display:inline-flex; align-items:center; color:white">
                        <v-icon v-if="item.hasPassword" color="white" style="margin-left:-24px">enhanced_encryption</v-icon>
                        <span style="line-break:anywhere">
                        {{ item.serverName}}
                        </span>   
                        <v-spacer/>           
                        <v-text-field 
                        v-if="item.hasPassword"
                        style="max-width:200px;"
                        class="pl-1"
                        v-model="item.password"
                        label="Enter Password"
                        dark
                      ></v-text-field>
                      <v-spacer/>           
                      <v-btn :disabled="triedJoin || !claimNameValid" @click="createServerJoinRequest(item)" color="brown darken-4" dark>
                        Join Server
                        </v-btn>
                      <v-progress-circular
                        v-if="connecting"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                      </div>     
                      <v-divider class="mt-2"/>                 
                    </li>
                  </ul>
                </v-img>
                
                  <div v-else-if="!gotServers" style="text-align:center; color:rgb(0,0,0,0.66)">
                    Claim name before getting servers
                  </div>

                  <div v-else style="text-align:center; color:rgb(0,0,0,0.66)">
                    Found No Servers
                  </div>                  
            </v-img>
          </v-card>
        </v-col>
        
        <v-col md="4" sm="6">
          <v-card>
            <v-img :src="require('../assets/parchment background.jpg')">
              <v-card-title class="headline" style="justify-content:center">Host Game</v-card-title>
              <div v-if="!admin && !isDm" style="display:flex; justify-content:space-evenly">
                <v-btn small @click="seeFreeDialog = true" :disabled="triedJoin">Play For Free</v-btn>
              </div>
              <div class="ml-1 pt-1" style="width:100%; display:inline-grid; justify-content:center" v-if="admin || isDm">
                <v-form v-model="serverValid">
                <v-text-field
                style="width:300px"
                  :disabled="connected"
                  class="pl-1"
                  id="ServerName"
                  v-model="unsetServerName"
                  label="Enter Server Name"
                  :rules="[rules.serverNameLength]"
                ></v-text-field>
                <v-text-field
                  :disabled="connected"
                  class="pl-1"
                  v-model="serverPassword"
                  label="Enter Password(optional)"
                  :rules="[rules.serverPasswordLength]"
                ></v-text-field>
                </v-form>
                <v-btn :disabled="connected || connecting || !serverValid" @click="createServer">launch server</v-btn>
              </div>
            </v-img>              
          </v-card>
        </v-col>
      </v-row>
      </v-img>      
    </div>
    <div v-if="connected && (admin || isDm)">
    
    <v-card elevation="4" dark class="rounded-0" style="border-style:ridge;border-width:thick;border-top:0px;border-left:0px;border-right:0px">
    <div style="display:flex; align-items:center" class="pa-2">
        Server Name: {{serverName}} 
        <v-spacer/>
        Password: <v-text-field style="width:150px; display:inline-flex" :value="serverPassword" disabled :type="showPassword"></v-text-field><v-icon @click="showPassword = showPassword == 'password' ? 'none' : 'password'">visibility</v-icon>
        <v-spacer/>
        <v-btn class="mb-2 ml-2" @click="closeServer">close server</v-btn>
        <v-spacer/>
      </div>      
        <ul v-if="(admin || isDm) && players.length > 0" >
          Player List:
          <table style="border-style:groove; margin-bottom:6px">                
                <tr v-for="(item, index) in players" :key="index" > 
                    <td>
                      <span v-if="item.connected" style="color:green"> {{ item.playerName }} </span>
                      <span v-else style="color:red"> {{ item.playerName }} </span>
                    </td>     
                    <td><v-btn class="ma-2" @click="kick(item)">kick</v-btn></td>
                    <td><v-btn class="ma-2" @click="getCharacterSheet(item)">View Character Sheet</v-btn></td>
                </tr>
              </table>  
        </ul>
        </v-card>
        <roller 
        :rollRequests="rollRequests" 
        :players="players" 
        :newCommand="newCommand" 
        :admin="admin" 
        :username="credentials.username"
        :password="credentials.password"
        @newRoll="newRoll" 
        @sendNotes="sendGroupNotes"
        ></roller>
    </div>

    <div v-if="connected && (!admin && !isDm)">
      <v-img :src="require('../assets/dark parchment background.jpg')">
      connected as {{ playerName }} to server: {{ serverName }}
      <character-sheet
        :connection="receiverConnection"
        :newRoll="recentRoll"
        :setCharacter="setCharacter"
        :communalUpdate="communalUpdate"
        :username="credentials.username"
        :password="credentials.password"
        :name="playerName"
      ></character-sheet>
      </v-img>
    </div>

    <v-dialog :persistent="loggingIn" v-model="loginDialog" width="600">
      <v-card dark>
          <v-card-title style="justify-content:center"> Login </v-card-title>
          <v-text-field class="ml-1" id="username" label="User Name/Email"></v-text-field>
          <v-text-field class="ml-1" id="password" type="password" label="Password"></v-text-field>
        <v-card-actions class="pt-0 px-2">
          <v-col>            
            <v-row style="justify-content:space-around; align-items:center">              
              <v-btn style="width:100%" color="blue" dark @click="checkPassword(); loggingIn = true;">
                  Login
                </v-btn>                                                   
            </v-row>
            <v-row style=" justify-content:space-around; align-items:center">
              <v-checkbox label="Stay Logged In" v-model="stayLoggedIn"></v-checkbox>
            </v-row>
            <v-row  style=" justify-content:space-around;">              
              <v-btn style="width:250px" class="my-1" color="blue" dark @click="registerAccountDialog = true; loginDialog = false">
                Register Account
              </v-btn>              
              <v-btn style="width:250px" class="my-1" color="blue" dark @click="seeFreeDialog = true; loginDialog = false">
                Play Free
              </v-btn>
            </v-row>
          </v-col>
          
        </v-card-actions>

        <v-overlay :absolute="true" v-model="loggingIn">
          <v-card>
            Logging In...
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
          </v-card>
        </v-overlay>

      </v-card>
    </v-dialog>

    <v-dialog v-model="registerAccountDialog" width="450">
      <v-card dark class="pa-4">     
        <v-card-title style="justify-content:center"> Register Account </v-card-title>   
        <div v-if="registerAccountDialog">
          <v-form v-model="registerAccountValid">
          <v-text-field label="Patreon Email" v-model="email" :rules="[rules.email, rules.emailLength]"></v-text-field>          
          <v-text-field
            v-model="password"            
            type="password"
            label="Password"
            hint="At least 6 characters"
            :rules="[rules.alphaNumeric, rules.passwordLength]"
          ></v-text-field>
          <v-text-field
            v-model="passwordConfirm"                     
            type="password"
            label="Confirm Password"
            :rules="[password == passwordConfirm || 'Passwords do not match']"
          ></v-text-field>
          <v-text-field v-model="patreonCode" label="Email Code(optional)"></v-text-field>
          </v-form>
        </div>
        <v-card-actions>          
          <div v-if="registerAccountDialog">
            <v-btn color="blue" :disabled="!registerAccountValid" text @click="registerAccount()">
            Register Account
          </v-btn>
          <v-btn x-small color="red" text @click="emailTutorial = true">
            Whats an Email Code?
          </v-btn>
          </div>
        </v-card-actions>

        <v-overlay :absolute="true" v-model="registering">
          <v-card>
            Registering...
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
          </v-card>
        </v-overlay>
      </v-card>
    </v-dialog>    

    <v-dialog v-model="emailTutorial" width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Getting An Account
        </v-card-title>
        <v-card-text>
        <b>Whats an Email Code?</b>
        <br/><br/>There are two types of Akashic Paths accounts, the player account, and a premium account. A player account allows you to play in games, (though you don't need one to do so) but it also lets you level up your classes and pick perks if you're playing in a premium accounts games. If you only want a player account, then you do not need to enter a patreon code.
        <br/><br/>With a premium account you can host games premium games, which has unlimited roles, has saving and uploading ability, and can give class experience. To get a premium account you must be a subscriber first, to get one go to: <a href="https://www.patreon.com/AkashicPaths">Patreon</a>        
        
        <br/><br/><b>Okay i have a subscription, what next?</b>
        <br/> Once you have registered for the patreon an email from Akashic Paths will be sent to the email you used to sign up for patreon that will include a code, thats what an email code is. If you created a player account before a premium account you and didn't use the same email for both the player account and the premium account you will need to make a second account, otherwise you will need two accounts.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="uploadDialog" width="400">
      <v-card>
        <v-card-title class="headline brown darken-4" style="color:white">
          Upload Saved Game
          <v-spacer/>
          <v-tooltip right style="margin-right:4px;">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="white">help_outline</v-icon>
            </template>
            <span>Copy and paste a saved text file into the box below and click upload</span>
          </v-tooltip>
        </v-card-title>
        <v-textarea v-model="uploadString" style="background-color:antiquewhite; margin-top:0px"></v-textarea>
        <v-card-actions style="background-color:antiquewhite; justify-content:center; margin-top:0px">
          <v-btn                        
            @click="uploadGame(); uploadDialog = false;">
            upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="downloadDialog" width="400" height="400">
      <v-card>
        <v-card-title class="headline brown darken-4" style="color:white">
          Download Current game
          <v-spacer/>
          <v-tooltip right style="margin-right:4px;">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="white">help_outline</v-icon>
            </template>
            <span>Click the copy button and save the text into a text file<br/><br/>To upload the game copy and paste the string into the box from the upload menu.</span>
          </v-tooltip>
        </v-card-title>
        <v-textarea v-model="downloadString" style="background-color:antiquewhite; margin-top:0px"></v-textarea>
        <v-card-actions style="background-color:antiquewhite; justify-content:center; margin-top:0px">
          <v-btn @click="copyToClip()">Copy</v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="snackbar"
        :timeout="1000"
      > Copied!
    </v-snackbar>
    </v-dialog>

    <v-dialog v-model="disconnectedDialog" width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          You've been Disconnected
        </v-card-title>
        <v-card-text>
          <span v-if="tryingReconnect">
            Trying to reconnect now
          </span>
          <span v-else>
          Sorry Bruh
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="seeCharacterSheetDialog" v-model="seeCharacterSheetDialog" width="100%" height="100%">
      <v-card>
        <v-card-title class="headline brown darken-2" style="justify-content:center; color:white; font-size:32px!important">
           {{setTempCharacterSheet.name}} Character Sheet
        </v-card-title>
      <character-sheet
        :key="characterSheetID"
        :setCharacter="setTempCharacterSheet"
        :tempPlayerRolls="tempPlayerRolls"
        :tempCustomDialogs="tempCustomDialogs"
        :isGM="true"
      ></character-sheet>    
      </v-card> 
    </v-dialog>

    <v-dialog v-model="seeFreeDialog" max-width="600">
      <v-card dark>
        <v-card-title style="justify-content:center; font-size:32px" class="mb-2">
           Play Free!
        </v-card-title>
        <v-divider/>
        <v-card-text class="mt-6" style="text-align:center; color:white">
          Click Below to play free!<br/>
          <br/>Playing free does not have all the features of the program, but is all you need to try and enjoy the Akashic Paths.
          <br/><br/>If you'd like to try out the full game, as well as support the Akashic Paths continued developement, or you'd like to join the discord, where you will get updates, patch notes, and talk to the active community, check out the support page!
          <br/>
        </v-card-text>    
        <v-divider/> 
        <v-card-actions style="justify-content:space-evenly">                   
          <v-btn class="mr-8 my-4" color="red" dark @click="playFree(); seeFreeDialog = false">Play Free!</v-btn>
          <v-btn class="ml-8 my-4" color="green" dark :to="`/support`">Support</v-btn>
        </v-card-actions>
      </v-card> 
    </v-dialog>

  </v-app>
</template>
<script>
import CharacterSheet from "./CharacterSheet";
import Roller from "./Roller";
import SenderConnection from "./senderConnection";
import ReceiverConnection from "./receiverConnection";
import CharacterManager from "./characterManager"
export default {
  name: "App",
  components: {
    Roller,
    CharacterSheet,
    CharacterManager,
  },
  data() {
    return {
      rules: {
        alphaNumeric: v => (v && /^[a-zA-Z0-9!@#$%^&*]+$/i.test(v)) || 'Password contains illegal character',
        passwordLength: v => (v.length > 5) || 'Password is not long enough',
        nameLength: v => v.length <= 60 && v.length >= 2 || "Name must be between 2 and 60 characters",
        legalName: v => !v.includes("!-!-!") || "Name Contains Illegal String",
        serverNameLength: v =>( v.length <= 50 && v.length >= 3) || "Sever name must be between 3 and 50 characters",
        serverPasswordLength: v => v.length <= 20 || "Sever password cannot be longer than 20 characters",
        email: v => {
                let emailRegex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi
                return emailRegex.test(String(v)) || 'Please enter a valid email address'
            },
        emailLength: v=> (v.length < 100 && v.length > 5) || 'Email must be between 5 and 100 characters',
        // email: v => {
        //         let emailRegex = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi
        //         return emailRegex.test(String(v)) || 'Please enter a valid email address'
        // },
      },
      rollingItems:[],
      playInterval: {},
      lastCheckIn: "",
      showerCharacterManager:false,
      gotServers:false,
      registerAccountDialog:false,
      claimNameValid:true,
      registerAccountValid:true,
      email:"",
      patreonCode:"",
      isDm: false,
      admin: false, 
      isPlayer:false,
      password:"",
      passwordConfirm:"",
      credentials:{username:"", password:"", token:""},
      stayLoggedIn:false,
      newCommand:{},
      downloadString:"",
      groupNotes:``,
      uploadString:"",
      setCharacter:{},
      communalUpdate:{},
      unclaimedName:"",
      unsetServerName:"",
      serverName: "",
      serverPassword:"",
      showPassword:"password",
      serverValid: true,
      seeCharacterSheetDialog: false,
      setTempCharacterSheet: {},
      tempPlayerRolls:[],
      tempCustomDialogs:[],
      characterSheetID:0,
      loginDialog: false,
      uploadDialog: false,
      downloadDialog: false,
      settingsMenu: false,
      connected: false,
      joinedServer: "",
      servername: "",      
      serverList: [],
      controller: null,
      peerConnection: null,
      dataChannel: null,
      offer: null,
      response: "",
      nameError: false,
      interval: null,
      players: [],
      connections: [],
      playerName: "",
      recentRoll: {},
      triedJoin: false,
      connecting: false,
      registering:false,
      loggingIn:false,
      emailCodeTutorial:false,
      emailTutorial:false,      
      connectedInterval: {
        interval:{},
        lastCheckIn: Date.now()
      },
      lastConnectedServer: {},
      url:
        window.location.href == "http://localhost:8080/"
          ? "http://localhost:7071/api/HttpTrigger1"
          : "/api/HttpTrigger1",
      senderConnection: {},
      receiverConnection: {},
      rollRequests: {},
      disconnectedDialog: false,
      tryingReconnect: false,
      hasPlayerAccount:false,
      seeFreeDialog:false,
      snackbar:false,
    }
  },
  mounted(){
    let credentials = document.cookie
    let creds = credentials.substring(7).split(",")
    if(creds.length == 2){
      this.checkPassword(creds[0],creds[1])
    }    
    // arr.forEach(obj=>{
    //   console.log(obj)
    //   if(obj.imgsrc && obj.imgsrc.includes("https://files.d20.io")){
    //     obj.imgsrc = obj.imgsrc.substr(0,8) + "s3.amazonaws.com/" + obj.imgsrc.substr(8)
    //     console.log("ran", obj.imgsrc)
    //   }      
    // })
    // console.log(JSON.stringify(arr))
    //this.checkPassword
    //-------Code for the map text file shrinker--------
    // let arr = "map here"
    // arr.forEach(obj=>{
    //   if(obj.imgsrc && obj.imgsrc.includes("https://files.d20.io")){
    //     obj.imgsrc = obj.imgsrc.substr(0,8) + "s3.amazonaws.com/" + obj.imgsrc.substr(8) 
    //   }   
    // })
    // console.log(JSON.stringify(arr))
  //   let arr = *arr here*
  //   console.log("prearray", arr)
  //   let parsedArr = []
  //   let neededItems = ['_type','_subtype',"top","width","height","rotation","left","layer","imgsrc","bar1_value","bar1_max","bar2_value","bar2_max","bar3_value","bar3_max","gmnotes","name","showname","barrierType","fill","_path","oneWayReversed","scaleX","scaleY","stroke","stroke_width","text","font_family","font_size","color","tooltip","show_tooltip","showplayers_name", "isLocked", "isOpen", "isSecret", "path", "x", "y"]
  //   arr.forEach(obj=>{
  //     let newObj = {}
  //     if(obj.imgsrc && obj.imgsrc.includes("https://files.d20.io")){
  //       obj.imgsrc = obj.imgsrc.substr(0,8) + "s3.amazonaws.com/" + obj.imgsrc.substr(8)
  //       console.log("ran", obj.imgsrc)
  //     }  
  //     if(obj._type == "graphic" && obj._subtype == "token" && obj.imgsrc == ""){
  //       console.log()
  //     }else{
  //       neededItems.forEach(item=>{        
  //       if(obj[item]) newObj[item] = obj[item]        
  //     })      
  //     parsedArr.push(newObj)
  //     }
  //   })
  //   //console.log("after arr", parsedArr)
  //   console.log(JSON.stringify(parsedArr))    
  },
  methods: {
    async callApi() {
      fetch("/api/HttpTrigger2?name=yeet2").then(async (response) =>
        console.log(await response.text())
      )
    },

    async createServer() {
      this.lastCheckIn = new Date().getTime()

      this.playInterval = setInterval(()=>{
        let players = false
        this.players.forEach(player =>{
          if(player.connected == true){
            players = true
          }
        }) 
        if(players){
          let newTime = new Date().getTime()
          //let difference = Math.round((newTime-this.lastCheckIn)/1000/60)
          this.lastCheckIn = newTime
          // fetch(this.url, {
          //   method: "POST",
          //   body: JSON.stringify({
          //     command: "addMinutes",
          //     email: this.credentials.username,
          //     minutes:difference
          //   }),
          // })
        }       
      }, 1000 * 60 * 10)
      
      this.serverName = document.getElementById("ServerName").value

      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "createServer",
          serverName: this.serverName,
          password: this.serverPassword,
          credentials:{username:this.credentials.username, password:this.credentials.password},
        }),
      }).then(async (response)=>{
        let responseText = await response.text()
        if(responseText == "duplicateServerName"){
          window.alert("Sorry that server name is already taken, please try again")
          this.serverName = ""
        }else{
          this.connected = true
          this.interval = setInterval(async () => {
            fetch(this.url, {
              method: "POST",
              body: JSON.stringify({
                command: "getJoinRequests",
                serverName: this.serverName,
                password:this.serverPassword,
                credentials:{username:this.credentials.username, password:this.credentials.password}
              }),
            }).then(async (response) => {
              let responseText
              let responseJson
              try {
                responseText = await response.text()
                if(responseText == "forceClose"){
                  console.log("forceClose")
                  window.onbeforeunload = {}
                  location.reload()
                }else{
                  responseJson = JSON.parse(responseText)
                }
                console.log("reponseJson", responseJson)
              } catch (err) {
                console.log("no new connections", err)
                console.log("reponse", response)
              }
              if(responseJson) {
                responseJson.forEach(response=>{              
                  this.addPlayer(response[1])
                })
              }
            })
            // this.autoSave()
            // this.hasAutoSave()
        }, 1000 * 10)
        }
      })
    },

    async addPlayer(request) {
      //this.createAdminConnection(request)
      let player = {}
      player.playerName = request.playerName      
      player.senderConnection = new SenderConnection(
        () => this.onAdminOpen(player),
        (data) => this.onAdminMessage(data, player),
        () => this.onAdminClose(player),
        () => this.adminConnect(player, request)
      )            
    },

    async adminConnect(player, request){
      await player.senderConnection.connect(request.connectionCode)
    },

    onAdminOpen(player) {
      let existingPlayer = this.players.find(existingPlayer=> existingPlayer.playerName.trim() == player.playerName.trim())
      if(existingPlayer){
        player.senderConnection.send(JSON.stringify({command:"setPlayer", data:existingPlayer.characterSheet}))
        player.characterSheet = existingPlayer.characterSheet
        player.remainingRolls = existingPlayer.remainingRolls
        this.players = this.players.filter(oldplayer => oldplayer.playerName.trim() != player.playerName.trim())
        if(existingPlayer.remainingRolls && existingPlayer.remainingRolls.length > 0){
          existingPlayer.remainingRolls.forEach(roll =>{
            player.senderConnection.send(JSON.stringify(roll))
          })
        }else{
          player.remainingRolls = []
          player.customDialogs = []
        }        
      }else{
        player.characterSheet = {}   
        player.remainingRolls = []
        player.customDialogs = []
      }
      player.connected = true
      player.lastInterval = Date.now()
      player.sendInterval = setInterval(()=>{
        console.log("sending to player " , player.playerName)
        player.senderConnection.send(JSON.stringify({command:"stillConnected"}))
        if(Date.now() - player.lastInterval > 90000){
          console.log("timing out player ", player)
          player.connected = false
          clearInterval(player.sendInterval)
        }
      }, 30000)
      this.players.push(player)
      this.players[player.playerName] = player
      this.newCommand={type:"newPlayer", fromPlayer: player}
      let groupNotes = this.groupNotes
      player.senderConnection.send(JSON.stringify({command:"communalUpdate", notes:groupNotes}))
      if(this.admin){
        player.senderConnection.send(JSON.stringify({command:"getUsername"}))
      }
    },

    onAdminMessage(e, player) {
      console.log("got connection from player", e, player.playerName)
      let message = JSON.parse(e)

      if (message.type == "selected") {
        let index = player.remainingRolls.findIndex(roll=>roll.rollId == message.rollId)
        if(index != -1){
          player.remainingRolls.splice(index, 1)
        }
        //player.remainingRolls = player.remainingRolls.filter(roll => roll.rollId != message.rollId)
        // if (message.option.uiType == "feats") {
        //   //player.characterSheet.feats.push(message.option)
        // } else {
        //   if (player.characterSheet[message.option.uiType] == null) {
        //     player.characterSheet[message.option.uiType] = []
        //   }
        //   //player.characterSheet[message.option.uiType].push(message.option)
        // }
      } else if (message.command == "requestRoll" || message.command == "requestWeaponEnchantment") {
        this.rollRequests = { message, player }
      } else if (message.command == "giveTeamworkFeat") {
        let target = this.players.find((player) => message.player == player.playerName)
        let response = {}
        response.options = [message.feat]
        response.options[0].playerNames = null
        response.options[0].from = player.playerName
        response.command = "newRoll"
        response.type = "feats"
        target.senderConnection.send(JSON.stringify(response))
        let index = player.remainingRolls.findIndex(roll=>roll.rollId == message.rollId)
        if(index != -1){
          player.remainingRolls.splice(index, 1)
        }
      }else if(message.command == "characterSheet"){
        if(message.type && message.type2){          
           player.characterSheet.characterStats[message.type2][message.type] = message.data
           this.$nextTick(() => {
              this.setTempCharacterSheet = {data:player.characterSheet, name:player.playerName}
            })
            return
        }
        if(message.data.type){
          if(message.data.type2){
            player.characterSheet[message.data.type2][message.data.type] = message.data
          }else{
            player.characterSheet[message.data.type] = message.data
          }
        }else{
          player.characterSheet = message.data
        }
        if(this.setTempCharacterSheet.name == player.playerName && this.seeCharacterSheetDialog == true){
            this.$nextTick(() => {
              this.setTempCharacterSheet = {data:player.characterSheet, name:player.playerName}
            })
          }
      }else if(message.command == "usedPotion"){
        this.newCommand={type:"usedPotions", fromPlayer: player, potion:message.potion}
      }else if(message.command == "usedGear"){
        this.newCommand={type:"usedGear", fromPlayer: player, gear:message.gear}
      }else if(message.command == "sendGold"){
        this.newCommand={type:"sendGold", fromPlayer: player, gold:message.gold}        
      }else if(message.command == "buyItem"){
        this.newCommand = {type:"buyItem", fromPlayer: player, item:message.item}
      }else if(message.command == "stillConnected"){
        console.log("got from player")
        player.lastInterval = Date.now()
      }else if(message.command == "giveUsername"){
        player.username = message.username
        this.players.splice(0,0,{})
        this.players.splice(0,1)
      }else if(message.command == "tradeItem"){
        let target = this.players.find((player) => message.item.target == player.playerName)
        if(message.item.statsForAbilities){
          message.item.statsForAbilities.bonusAtk = 0
          message.item.statsForAbilities.bonusDmg = 0
          message.item.statsForAbilities.dieSteps = 0          
        }
        let response = {}
        response.options = [message.item]
        response.command = "newRoll"
        response.type = message.item.uiType
        target.senderConnection.send(JSON.stringify(response))
      }else if (message.command == "sendGoldTo"){
        let target = this.players.find((player) => message.target == player.playerName)
        let response = {command:"newRoll", amount:message.gold, type:"gold"}
        target.senderConnection.send(JSON.stringify(response))
      }else if(message.command == "groupNotes"){
        this.sendGroupNotes(message.notes)
      }else if(message.command == "itemRoll"){
        if(this.rollingItems[message.item.id] && !this.rollingItems[message.item.id].done){
          this.rollingItems[message.item.id].rolls.push({name:player.playerName,roll: message.roll})
          if(this.rollingItems[message.item.id].rolls.length == this.players.length){
            this.sendWonderousItems(message)
            clearTimeout(this.rollingItems[message.item.id].timer)
          }
        }else if(!this.rollingItems[message.item.id]){
          this.rollingItems[message.item.id] = {timer:{},rolls:[], done:false}          
          this.rollingItems[message.item.id].rolls.push({name:player.playerName,roll: message.roll})
          this.rollingItems[message.item.id].timer = setTimeout(() => {
            this.sendWonderousItems(message)
          }, message.timeLeft * 1000 + 5000)
        }
      }else if(message.command == "getPlayerNames"){
        console.log("got get player names")
        let playerNames = this.players.map(player => player.playerName)
        //let target = this.players.find((player) => message == player.playerName)
        player.senderConnection.send(JSON.stringify({command:"playerNames", data:playerNames}))
      }else if(message.command == "sendPerk"){
        let target = this.players.find((player) => message.target == player.playerName)
        target.senderConnection.send(JSON.stringify({command:"newRoll", options:[message.perk], type:"perks"}))
      }else if(message.command == "CustomDialogs"){
        player.customDialogs = message.data
        if(this.seeCharacterSheetDialog && this.setTempCharacterSheet.name == player.playerName){
           this.tempCustomDialogs = message.data
           //this.characterSheetID = Math.random()
        }
      }
    },

    sendWonderousItems(message){
      let highest = {name: "", roll:0}
      let rollString = "Rolls for item: " + message.item.name + ", "
      this.rollingItems[message.item.id].rolls.forEach(roll=>{
        rollString += roll.name + " rolled " + roll.roll + ", "
        if(roll.roll > highest.roll){
          highest.name = roll.name
          highest.roll = roll.roll
        }
      })

      this.rollingItems[message.item.id].done = true
      this.newCommand={type:"wonderousItemRolls", rollString}
      this.players.forEach(player=>{
        let response = {}        
        response.command = "newRoll"
        response.type = "wonderousItems"
        response.clearItem = message.item.id
        if(player.playerName == highest.name){
          response.options = [message.item]          
        }
        player.senderConnection.send(JSON.stringify(response))
      })
    },

    sendGroupNotes(groupNotes){
      this.groupNotes = groupNotes
      this.newCommand = {type:"groupNotes", notes:groupNotes}
      this.players.forEach(player=>{
        player.senderConnection.send(JSON.stringify({command:"communalUpdate", notes:groupNotes}))
      })
    },

    onAdminClose(player){
      player.connected = false
      clearInterval(player.sendInterval)
    },

    onPlayerOpen() {
      this.connected = true
      this.tryingReconnect = false
      this.disconnectedDialog = false
      this.connectedInterval.lastCheckIn = Date.now()
      this.connectedInterval.interval = setInterval(()=>{
        console.log("sending to Dm")
        this.receiverConnection.send(JSON.stringify({command:"stillConnected"}))
        if(Date.now() - this.connectedInterval.lastCheckIn > 90000){
          console.log("timing out DM and trying to reconnect")
          this.receiverConnection.conn.close()
          clearInterval(this.connectedInterval.interval)
          this.tryingReconnect = true
          this.createServerJoinRequest(this.lastConnectedServer, true)
        }
      }, 30000)
      if(!this.credentials.username){
        fetch(this.url, {
          method: "POST",
          body: JSON.stringify({
            command: "freeLogin",
          }),
        })
      }
      this.lastCheckIn = new Date().getTime()
      this.playInterval = setInterval(()=>{
        if(this.connected == true){
          let newTime = new Date().getTime()
          let difference = Math.round((newTime-this.lastCheckIn)/1000/60)
          this.lastCheckIn = newTime
          fetch(this.url, {
            method: "POST",
            body: JSON.stringify({
              command: "addMinutes",
              email: this.credentials.username,
              minutes:difference
            }),
          })
        }
      }, 1000 * 60 * 10)
    },

    onPlayerMessage(e) {
      let message = JSON.parse(e)
      if(message.command == "newRoll") {
        this.recentRoll = message
      }else if(message.command == "setPlayer"){
        this.setCharacter = message
      }
      else if(message.command == "communalUpdate"){
        this.communalUpdate = message
      }else if(message.command == "stillConnected"){
        this.connectedInterval.lastCheckIn = Date.now()
      }else if(message.command == "getUsername"){        
        if(this.credentials.username){
          this.receiverConnection.send(JSON.stringify({command:"giveUsername", username:this.credentials.username}))
        }
      }
    },

    onPlayerClose() {
      this.connected = false
      this.disconnectedDialog = true
      this.triedJoin = false
      this.serverList = []
      this.connecting = false
      if(this.connectedInterval.interval){
        clearInterval(this.connectedInterval.interval)
      }
    },

    closeServer() {
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "deleteServer",
          serverName: this.serverName,
        }),
      })
      clearInterval(this.interval)
      this.serverName = ""
      location.reload()
    },

    getServerList() {
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "getServerList",
        }),
      }).then(async (response) => {
        let responseText = await response.json()
        responseText.forEach(server=>{
          server.password = ""
        })
        this.serverList = responseText
      })
    },

    async createServerJoinRequest(server, isReconnect) {
      this.lastConnectedServer = server
      let serverName = server.serverName
      let password = server.password
      this.triedJoin = true 
      this.connecting = true
      this.isDm = false
      this.admin = false
     
      this.serverList = [server]      
      if (this.unclaimedName.length == 0) {
        this.nameError = true
        return
      }

      this.serverName = serverName
      this.playerName = this.unclaimedName      
      this.nameError = false

      this.receiverConnection = await new ReceiverConnection(
        () => this.onPlayerOpen(),
        (data) => this.onPlayerMessage(data),
        () => this.onPlayerClose(),
        () => this.sendServerJoinRequest(isReconnect, password, serverName)
      )
    },

    sendServerJoinRequest(isReconnect, password, serverName){
      let id = this.receiverConnection.getId()
      console.log("created request and sent", id)
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "createJoinRequest",
          playerName: this.playerName,
          password: password,
          serverName: serverName,
          connectionCode: id,
          isReconnect
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        console.log(responseText)
        if(responseText == "badPassword"){
          window.alert("wrong server password")
          this.triedJoin = false 
          this.connecting = false 
          this.getServerList()
        }
      })
    },

    sendMessage(item) {
      if (item) {
        console.log(item)
        item.senderConnection.send("personal send")
      } else {
        console.log(this.peerConnection)
        this.dataChannel.send("yeet my meet")
      }
    },

    async checkPassword(user,pass) {
      console.log("check password")
      let password
      let username
      if(!user && !pass){
        password = document.getElementById("password").value
        username = document.getElementById("username").value
      }else{
        username = user
        password = pass
      }
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "checkPassword",
          username,
          password
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        if(responseText == "patreon" || responseText == "player"){
          fetch(this.url, {
            method: "POST",
            body: JSON.stringify({
              command: "addLogin",
              username,
            }),
          })

        }
        if(responseText =="patreon"){
          this.admin = true
          this.loginDialog = false
          this.credentials.username = username
          this.credentials.password = password
          this.loggingIn = false
          this.hasPlayerAccount = true
          if(this.stayLoggedIn){
            //let cookie = "cookie="+username+","+password+"; max-age=max-age-in-seconds=15552000"
            //let cookie = "cookie=admin1,aaa;max-age=max-age-in-seconds=15552000"
            let expirationDate = new Date();
            expirationDate.setMonth(expirationDate.getMonth() + 6);
            const cookieString = `${"cookie"}=${username+","+password};expires=${expirationDate.toUTCString()};path=/`;
            document.cookie = cookieString
          }
        }else if(responseText == "player"){         
          this.loginDialog = false
          this.loggingIn = false
          this.credentials.username = username
          this.credentials.password = password
          this.hasPlayerAccount = true
          if(this.stayLoggedIn){
            let expirationDate = new Date();
            expirationDate.setMonth(expirationDate.getMonth() + 6);
            const cookieString = `${"cookie"}=${username+","+password};expires=${expirationDate.toUTCString()};path=/`;
            document.cookie = cookieString
            //let cookie = "cookie="+username+","+password+";max-age=max-age-in-seconds=15552000"
            //let cookie = "cookie=admin1,aaa;max-age=max-age-in-seconds=15552000"
          }
        }else{
          this.loggingIn = false
          this.admin = false
          this.loginDialog = true
          window.alert(responseText)
        }
      })
    },

    logout(){
      this.admin = false
      this.loginDialog = false
      this.credentials.username = ""
      this.credentials.password = ""
      this.loggingIn = false
      this.hasPlayerAccount = false
      let expirationDate = new Date();
      expirationDate.setMonth(expirationDate.getMonth() - 6);
      const cookieString = `${"cookie"}=${"username,password"};expires=${expirationDate.toUTCString()};path=/`;
      document.cookie = cookieString
    },

    // async checkPassword() {
    //   let password = document.getElementById("password").value
    //   let username = document.getElementById("username").value
    //   fetch(this.url, {
    //     method: "POST",
    //     body: JSON.stringify({
    //       command: "checkPassword",
    //       username,
    //       password,
    //       token: this.credentials.token,
    //     }),
    //   }).then(async (response) => {
    //     console.log(response)
    //     let responseText = JSON.parse(await response.text())
    //     console.log(responseText)
    //     if(responseText.token){
    //         this.credentials.token = responseText.token
    //       }
    //     if(responseText.accountType =="patreon"){          
    //       this.admin = true
    //       this.loginDialog = false
    //       this.credentials.username = username
    //       this.credentials.password = password
    //       this.loggingIn = false
    //       this.hasPlayerAccount = true
    //     }else if(responseText.accountType == "player"){
    //       this.loginDialog = false
    //       this.loggingIn = false
    //       this.credentials.username = username
    //       this.credentials.password = password
    //       this.hasPlayerAccount = true
    //     }else{
    //       this.loggingIn = false
    //       this.admin = false
    //       this.loginDialog = true
    //       window.alert(responseText)
    //     }
    //   })
    // },

    setPlayerName() {      
      this.playerName = this.unclaimedName
    },

    getCharacterSheet(player) {
      this.seeCharacterSheetDialog = true
      this.tempPlayerRolls = player.remainingRolls      
      this.tempCustomDialogs = player.customDialogs
      this.$nextTick(() => {
        this.setTempCharacterSheet = {data:player.characterSheet, name:player.playerName}
      })
    },
    
    newRoll(playerName, message){
      console.log("ran newRoll", playerName, message)
      let player = this.players.filter(player=> player.playerName == playerName)[0]
      player.remainingRolls.push(message)
    },


    maybeFastTrack() {
      if (window.location.href == "http://localhost:8080/") {
        // this.admin = true
        // this.loginDialog = false
        // this.credentials.username = "superAdmin"
      }
    },

    kick(player) {
      if(player.senderConnection){
        player.senderConnection.close()
      }
      let deleteIndex = this.players.indexOf(player)
      this.players.splice(deleteIndex, 1)       
    },

    downloadGame(){
      this.downloadString = ""
      this.players.forEach(player=>{
        if(player.characterSheet.characterStats){
          let playerData = {playerName:player.playerName, characterSheet: player.characterSheet}
          this.downloadString += JSON.stringify(playerData) + "!-!-!"
        }
      })      
      this.newCommand = {type:"getPotions", command:(currentPotions) => {
        this.downloadString += JSON.stringify(currentPotions)
        this.downloadString += "!-!-!"
        this.newCommand = {type:"getGear", command:(currentGear) => {
          this.downloadString += JSON.stringify(currentGear)
        }}
      }}
      this.downloadString += "GroupNotes:"
      this.downloadString += this.groupNotes
      this.downloadString += "!-!-!"
    },

    uploadGame(){
      let str = this.uploadString
      let saveArray = str.split("!-!-!")
      let items = {}
      saveArray.forEach(rawData =>{        
        if(rawData.substring(0,11) == "GroupNotes:"){
          this.groupNotes = rawData.substring(11)
          this.$nextTick(() => {
            this.newCommand = {type:"groupNotes", notes:rawData.substring(11)}
          })
          
        }else{
          let data = JSON.parse(rawData)
          if(data.playerName){
            let player = {}
            player.playerName = data.playerName
            player.characterSheet = data.characterSheet
            this.updateCharacterSheet(player.characterSheet)
            this.players.push(player)
          }else if(data[0].name == "Minor Mnemonic Enhancement"){
            items.parsedPotions = data
          }else if(data[0].stack){
            items.parsedGear = data          
          }
        }        
      })
      this.newCommand = {type:"setItems", items}
      
      
    },


    updateCharacterSheet(characterSheet){
      if(!characterSheet.characterStats.tempModifiers){
        characterSheet.characterStats.tempModifiers = {strength: 0,dexterity: 0,constitution: 0,intelligence: 0,wisdom: 0,charisma: 0,saves:0,fortitude:0,reflex:0,will:0, cmb:0, cmd:0, acrobatics: 0,diplomacy: 0,bluff: 0,climb: 0,disableDevice: 0,escapeArtist: 0,fly: 0,heal: 0,intimidate: 0,perception: 0,senseMotive: 0,spellcraft: 0,stealth: 0,perform: 0,survival: 0,knowArcana: 0,knowPlanes: 0,knowReligion: 0,knowNature: 0,craft: 0,swim:0}
      }
      if(!characterSheet.characterStats.modifiedStats){
        characterSheet.characterStats.modifiedStats = {strength: 10, dexterity: 10, constitution: 10, intelligence: 10, wisdom: 10, charisma: 10}
      }
      if(!characterSheet.statsForAbilities){
        characterSheet.statsForAbilities = {lvlForBab:false, atk:"strength", bonusAtk:0, dmg:"strength", bonusDmg:0, powerAttack:false,combatExpertise:false, cmb:"strength", ac:{abilityMod:"dexterity", armorCheckMod:0,deflection:0, armor:0,shield:0, natural:0,dodge:0,untyped:0}}
      }
      if(!characterSheet.statsForAbilities.combatExpertise){
        characterSheet.statsForAbilities.combatExpertise = false
      }
      if(!characterSheet.lists.maneuver){
        characterSheet.lists.maneuver = characterSheet.lists.manuevers
      }
      if(!characterSheet.notes){
        characterSheet.notes = ``
      }
      if(!characterSheet.xp){
        characterSheet.xp = 0
        characterSheet.nextLevel = 500
      }
      if(!characterSheet.lists.wonderousItems){
        characterSheet.lists.wonderousItems = []
      }
      if(characterSheet.lists.weapon[0]){
        characterSheet.lists.weapon.forEach(weapon=>{
          if(!weapon.statsForAbilities){
            weapon.statsForAbilities = { atkStat:"strength", bonusAtk:0, dmgStat:"strength", bonusDmg:0, dieSteps:0, sizeSteps:0}
          }
          if(!weapon.statsForAbilities.dieSteps){
            weapon.statsForAbilities.dieSteps = 0
          }
        })
      }      
      if(!characterSheet.xpLevel){
        characterSheet.xpLevel = 0
      }
      if(!characterSheet.characterStats.tempModifiers.negativeLevels){
        characterSheet.characterStats.tempModifiers.negativeLevels = 0
        characterSheet.characterStats.tempModifiers.armorCheckPenalty = 0
      }
      if(!characterSheet.characterStats.misc.combo) characterSheet.characterStats.misc.combo = []
      if(!characterSheet.characterStats.spellMastery){
        characterSheet.characterStats.spellMastery = {
          spellPower:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
          spellCriticalChance:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
          spellCriticalDamage:{universal:50, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
        }
      }
      if(!characterSheet.characterStats.spellMastery.modifier){
        characterSheet.characterStats.spellMastery.modifier = {
          spellPower:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
          spellCriticalChance:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
          spellCriticalDamage:{universal:0, fire:0, cold:0, acid:0, electricity:0, positive:0, negative:0},
        }
      }
      if(!characterSheet.characterStats.schoolMastery){
        characterSheet.characterStats.schoolMastery = {Air:0, Arcane:0, Curse:0, Dark:0, Death:0, Earth:0, Electricity:0, Fire:0, Flurry:0, Guardian:0, Heroic:0, Light:0, Power:0, Primal:0, Royal:0, Sakura:0, Shadow:0, Technique:0, Void:0, Water:0}
      }
    },

    playFree(){
      this.isDm = true
      this.isAdmin = false
      this.hasPlayerAccount = false
      this.credentials.username = "FreeAccount" + this.makeid(5)
      this.credentials.password = "AimWdFsMuznsPQx"
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "freeLogin",
        }),
      })
    },

    makeid(length){
      let result           = ''
      let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let charactersLength = characters.length
      for (let x = 0; x < length; x++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
          charactersLength))
      }
      return result
    },

    createAccount(){
      let email = document.getElementById("email").value
      let password = document.getElementById("accountPassword").value
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "createAccount",
          email,
          password
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        console.log("create account response:", responseText)
      })
    },

    getAccounts(){
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "getAccounts",
        }),
      }).then(async (response) => {
        let responseText = await response.json()
        console.log("get account response:", responseText)
      })
    },

    getAccount(){
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "getAccount",
        }),
      }).then(async (response) => {
        let responseText = await JSON.parse(response.text())
        console.log("get account response:", responseText)
      })
    },

    // migrateDatabase(){
    //   fetch(this.url, {
    //     method: "POST",
    //     body: JSON.stringify({
    //       command: "migrate",
    //     }),
    //   }).then(async (response) => {
    //     let responseText = await JSON.parse(response.text())
    //     console.log("get account response:", responseText)
    //   })
    // },

    deleteAccount(){
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "deleteAccount",
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        console.log("get account response:", responseText)
      })
    },

    registerAccount(){
      this.registering = true
      let command = "registerUser"
      if(this.patreonCode.length < 1){
        command = "createPlayerAccount"
      }
       fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: command,
          password:this.password,
          email:this.email,
          code:this.patreonCode,
        }),
      }).then(async (response) => {
        let responseText = await response.text()
        console.log("register user", responseText)
        if(responseText == "good"){
          this.registerAccountDialog = false
          document.getElementById("password").value = this.password
          document.getElementById("username").value = this.email
          this.loginDialog = true
          this.checkPassword()
        }else if(responseText == "account exists"){
          window.alert("An account with this email already exists!")
        }else{
          window.alert("Failed to register, please check your credentials and code again")
        }
        this.registering = false
      })      

    },
    
    getPatreonCalls(){
      fetch(this.url, {
        method: "POST",
        body: JSON.stringify({
          command: "getPatreonCalls",
        }),
      }).then(async (response) => {
        let responseText = await response.json()
        console.log("patreonapi calls", responseText)        
      })   
    },

    copyToClip(){
      navigator.clipboard.writeText(this.downloadString);
      this.snackbar = true
    }

    // autoSave(){
    //   this.downloadGame()
    //   console.log(this.downloadString)
    //   document.cookie = "mostRecentSave" + "=" + this.downloadString
    // },

    // hasAutoSave(){
    //   let decodedCookie = decodeURIComponent(document.cookie);
    //   console.log(decodedCookie)
    //   //let save =  document.cookie
    // },    
  },
}
//v2
</script>
<style>
.bars .v-image__image--contain{
  background-repeat: repeat-y;
}
.flipped {
  transform: rotateY(180deg);
}

.light::-webkit-scrollbar {
  width: 4px;
  margin-top:2px;
}

.light::-webkit-scrollbar-track {
  background: rgb(0,0,0,0);
}

.light::-webkit-scrollbar-thumb {
  background: rgb(140, 77, 8);  
  border-radius: 7px;
}
 .repeaty .v-image__image{
  background-repeat: repeat-y!important;
 }
</style>

